export const CONFIG = {
  GAME_WIDTH: 480,
  GAME_HEIGHT: 720,

  // Where the gameplay area ends (UI panel below)
  PLAY_AREA_TOP: 56,
  PLAY_AREA_BOTTOM: 540,

  // Player
  PLAYER_HP_MAX: 100,
  PLAYER_SPEED: 180,
  PLAYER_DAMAGE_BASE: 40,
  PLAYER_BULLET_SPEED: 700,
  PLAYER_INVULN_MS: 500,
  PLAYER_KNOCKBACK: 180,

  // Enemies
  ENEMY_BASE_HP: 75,
  ENEMY_BASE_SPEED: 50,
  ENEMY_BASE_DAMAGE: 15,
  ENEMY_DISPLAY_SCALE: 2.5,
  BOSS_DISPLAY_SCALE: 3.0,
  ENEMY_TYPES: {
    // Basic-level monsters
    slime: { hp: 60, speed: 38, damage: 12 },
    bat: { hp: 45, speed: 70, damage: 10 },
    goblin: { hp: 80, speed: 55, damage: 15 },
    wolf: { hp: 70, speed: 80, damage: 18 },
    spider: { hp: 90, speed: 50, damage: 20 },
    // Advanced-level monsters (Crystal Caves)
    skeleton: { hp: 80, speed: 55, damage: 16 },
    darkKnight: { hp: 95, speed: 50, damage: 20 },
    cursedVillager: { hp: 70, speed: 60, damage: 15 },
    slimeVariant: { hp: 65, speed: 45, damage: 14 },
    // Expert-level monsters (Wizard's Sanctum)
    redMage: { hp: 85, speed: 60, damage: 18 },
    apprentice: { hp: 75, speed: 65, damage: 16 },
    royalSpider: { hp: 95, speed: 70, damage: 22 },
    fastSlime: { hp: 60, speed: 70, damage: 14 },
  },

  // Boss
  BOSS_HP: 600,
  BOSS_DAMAGE: 25,
  BOSS_SPEED: 30,
  BOSS_DASH_SPEED: 200,
  BOSS_DASH_INTERVAL_MS: 8000,
  BOSS_DASH_DURATION_MS: 1500,
  BOSS_MINION_HP: 30,

  // Per-level boss overrides. Forest Captain (expert) is the Master fight.
  BOSSES: {
    basic: { texture: 'boss-mistress', hpMult: 1.0, name: 'DARK\nMISTRESS!', subtitle: 'DARK MISTRESS' },
    advanced: { texture: 'boss-knight', hpMult: 1.5, name: 'FORSAKEN\nKNIGHT!', subtitle: 'FORSAKEN KNIGHT' },
    expert: { texture: 'boss-captain', hpMult: 3.0, name: 'FOREST\nCAPTAIN!', subtitle: 'FOREST CAPTAIN' },
  },

  // Combat
  COMBO_THRESHOLD_FOR_CRIT: 3,
  CRIT_CHANCE: 0.3,
  CRIT_MULTIPLIER: 2.0,

  // Drops
  DROP_CHANCE: 0.3,
  DROP_WEIGHTS: { heart: 35, gem: 40, speed: 10, shield: 10, doubleDmg: 5 },
  HEART_HP_AMOUNT: 20,
  GEM_XP_AMOUNT: 5,

  // Power-ups
  POWERUP_SPEED_MS: 10000,
  POWERUP_SPEED_MULT: 1.3,
  POWERUP_SHIELD_MS: 15000,
  POWERUP_DOUBLE_DMG_MS: 10000,

  // Wave plans by level. WAVES is kept as the basic alias for legacy code.
  LEVEL_WAVES: {
    basic: [
      {
        id: 1,
        durationMs: 60000,
        killTarget: 20,
        enemies: ['slime', 'bat'],
        spawnIntervalMs: 4000,
        speedMult: 1.0,
        multiSpawnChance: 0,
      },
      {
        id: 2,
        durationMs: 60000,
        killTarget: 25,
        enemies: ['slime', 'bat', 'goblin', 'wolf'],
        spawnIntervalMs: 3000,
        speedMult: 1.2,
        multiSpawnChance: 0,
      },
      {
        id: 3,
        durationMs: 75000,
        killTarget: 30,
        enemies: ['goblin', 'wolf', 'spider'],
        spawnIntervalMs: 2500,
        speedMult: 1.2,
        multiSpawnChance: 0.25,
      },
    ],
    advanced: [
      { id: 1, durationMs: 60000, killTarget: 9,  enemies: ['skeleton', 'slimeVariant'],                 spawnIntervalMs: 3500, speedMult: 1.0,  multiSpawnChance: 0 },
      { id: 2, durationMs: 60000, killTarget: 9,  enemies: ['skeleton', 'cursedVillager'],               spawnIntervalMs: 3300, speedMult: 1.05, multiSpawnChance: 0 },
      { id: 3, durationMs: 65000, killTarget: 10, enemies: ['darkKnight', 'cursedVillager'],             spawnIntervalMs: 3000, speedMult: 1.1,  multiSpawnChance: 0.1 },
      { id: 4, durationMs: 65000, killTarget: 10, enemies: ['darkKnight', 'skeleton', 'slimeVariant'],   spawnIntervalMs: 2800, speedMult: 1.1,  multiSpawnChance: 0.15 },
      { id: 5, durationMs: 70000, killTarget: 10, enemies: ['darkKnight', 'cursedVillager', 'skeleton'], spawnIntervalMs: 2600, speedMult: 1.15, multiSpawnChance: 0.2 },
    ],
    expert: [
      { id: 1, durationMs: 60000, killTarget: 12, enemies: ['apprentice', 'fastSlime'],              spawnIntervalMs: 2600, speedMult: 1.15, multiSpawnChance: 0.1 },
      { id: 2, durationMs: 60000, killTarget: 13, enemies: ['apprentice', 'redMage'],                spawnIntervalMs: 2400, speedMult: 1.15, multiSpawnChance: 0.15 },
      { id: 3, durationMs: 65000, killTarget: 14, enemies: ['redMage', 'royalSpider', 'fastSlime'],  spawnIntervalMs: 2200, speedMult: 1.2,  multiSpawnChance: 0.2 },
      { id: 4, durationMs: 70000, killTarget: 15, enemies: ['royalSpider', 'redMage', 'apprentice'], spawnIntervalMs: 2000, speedMult: 1.2,  multiSpawnChance: 0.25 },
      { id: 5, durationMs: 75000, killTarget: 15, enemies: ['royalSpider', 'redMage', 'apprentice', 'fastSlime'], spawnIntervalMs: 1800, speedMult: 1.25, multiSpawnChance: 0.3 },
    ],
  },

  // Default basic plan exposed as WAVES (backwards-compat for callers like HUDScene).
  get WAVES() { return this.LEVEL_WAVES.basic; },

  // Scoring
  XP_PER_KILL: 5,
  SCORE_PER_KILL: 10,
  SCORE_PER_CORRECT: 5,
  SCORE_PER_BOSS_KILL: 500,

  // Effects
  SHAKE_HIT_INTENSITY: 0.005,
  SHAKE_HIT_DURATION: 200,
  SHAKE_BOSS_INTENSITY: 0.018,
  SHAKE_BOSS_DURATION: 600,
  HIT_STOP_BOSS_MS: 60,

  COLORS: {
    BG: 0x1e1b4b,
    BG_DARK: 0x0f0d2c,
    BG_GRID: 0x312e81,
    BG_GRID_LIGHT: 0x4338ca,
    HERO: 0xd946ef,
    HERO_GLOW: 0xf0abfc,
    SLIME: 0x22c55e,
    BAT: 0x7c3aed,
    GOBLIN: 0xfb923c,
    WOLF: 0x9ca3af,
    SPIDER: 0x111827,
    BOSS: 0xef4444,
    BULLET: 0xfbbf24,
    BULLET_CRIT: 0xfde047,
    HEART: 0xef4444,
    GEM: 0x06b6d4,
    SPEED: 0xfbbf24,
    SHIELD: 0x60a5fa,
    DOUBLE_DMG: 0xd946ef,
    HP_GREEN: 0x22c55e,
    HP_YELLOW: 0xfbbf24,
    HP_RED: 0xef4444,
    UI_PRIMARY: 0xd946ef,
    UI_SECONDARY: 0x06b6d4,
    UI_GOLD: 0xfbbf24,
    UI_PANEL: 0x0f0d2c,
    UI_PANEL_BORDER: 0x312e81,
    OUTLINE_ACTIVE: 0xfde047,
    DAMAGE_TEXT: 0xef4444,
    HEAL_TEXT: 0x22c55e,
    CRIT_TEXT: 0xfbbf24,
  },
};

export const SAVE_KEY = 'verb-strike-save-v1';
